import React, { Component, Fragment, createRef } from "react";

import { CPagination } from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardFooter,
  Col,
  Row,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import ContentItemActivity from "./ContentItemActivity";
import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Dnd from "../DragAndDrop/DragAndDrop";
import Loading from "../Loading";
import ModalActivity from "../Modal/ModalActivity";
import NewContentModal from "../NewContentModal";

import "./css/contentActivity.css";

// O objeto 'selectStyles' foi removido pois agora usamos CSS puro.

class ContentComponentActivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selected: [],
      selectedLessons: [],

      // -- Estado dos Filtros --
      filter: {
        word: "",
        segment: { value: null, label: "Todos" },
        discipline: { value: null, label: "Todos" },
        serie: { value: null, label: "Todas" },
        module: { value: null, label: "Todos" },
        ability: { value: null, label: "Todos" }
      },
      segments: [],

      modalOrder: false,
      content: [],
      contentList: {
        type: null,
        list: []
      },
      type: this.props.type,
      disciplineId: this.props.discipline,
      newContentModal: false,
      maxItems: 24,
      currentPage: 1,
      lastPage: 1,
      contentLength: 0
    };

    this.timeToUpdate = createRef(3);
    this.countdown = null;
  }

  componentDidMount() {
    this.setType();
    this.pullData();
  }

  pullData = async () => {
    try {
      const typeToFetch = this.state.type || this.props.type || 0;

      const resp = await axios.get(
        `${URL.api}content/los/filterStructure/${typeToFetch}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      this.setState({
        segments: resp.data.data
      });
    } catch (err) {
      console.error("Erro ao buscar filtros", err);
    }
  };

  toggleModalOrder = () => {
    this.setState(prevState => ({ modalOrder: !prevState.modalOrder }));
  };

  setType = () => {
    const filter = this.props.general.filtered_content;

    if (filter && filter.type !== 0) {
      this.getLos();
    } else {
      this.getLos();
    }
  };

  changeInputName = e => {
    clearInterval(this.countdown);
    const value = e.target.value;

    this.setState(prevState => ({
      filter: { ...prevState.filter, word: value }
    }));

    this.timeToUpdate.current = 3;

    this.countdown = setInterval(() => {
      this.timeToUpdate.current -= 1;
      if (this.timeToUpdate.current === 0) {
        clearInterval(this.countdown);
        this.getLos();
      }
    }, 1000);
  };

  changeFilter = (prop, value) => {
    this.setState(
      prevState => {
        let filter = { ...prevState.filter };
        filter[prop] = value;

        if (prop === "segment") {
          filter.serie = { value: null, label: "Todas" };
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
        } else if (prop === "serie") {
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
        } else if (prop === "discipline") {
          filter.module = { value: null, label: "Todos" };
        }

        return { filter };
      },
      () => {
        this.getLos();
      }
    );
  };

  getLos = async () => {
    const { type, filter, disciplineId, currentPage, maxItems } = this.state;

    this.setState({ loading: true });

    const filters = {
      type,
      word: filter.word === "" ? null : filter.word,
      segment: filter.segment && filter.segment.value,
      discipline:
        filter.discipline && filter.discipline.value
          ? filter.discipline.value
          : disciplineId,
      serie: filter.serie && filter.serie.value,
      module: filter.module && filter.module.value,
      ability: null,
      content: true
    };

    try {
      const losResponse = await axios.post(
        `${URL.api}content/los/listLosFilter?page=${currentPage}&page_size=${maxItems}`,
        filters,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );

      const filteredContents = losResponse.data.data.map((item, index) => {
        if (index === 0) {
          const filteredContent = item.content.filter(
            contentItem =>
              contentItem.author.toLowerCase() === "educandus" ||
              contentItem?.user_id === this.props.user.user.id
          );
          return { ...item, content: filteredContent };
        }
        return item;
      });

      this.setState(
        {
          content: filteredContents,
          contentLength: losResponse.data.meta.total,
          currentPage: losResponse.data.meta.current_page,
          lastPage: losResponse.data.meta.last_page
        },
        () => {
          this.setState({ loading: false });
        }
      );
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  getSelected = select => {
    this.setState(prevState => {
      let newSelected = [...prevState.selected];
      let foundIndex = newSelected.findIndex(item => item.id === select.id);

      if (foundIndex !== -1) {
        newSelected.splice(foundIndex, 1);
      } else {
        newSelected.push(select);
      }

      let newList = [];

      if (this.props.type === 0) {
        newSelected.forEach(lesson => {
          if (lesson.slides) {
            lesson.slides.forEach(slide => {
              if (slide.checked) {
                slide.father = lesson.id;
                newList.push(slide);
              }
            });
          }
        });
      } else {
        newList = [...new Set(newSelected)];
      }

      const typeId = prevState.content[0]?.id;

      return {
        selected: newSelected,
        contentList: {
          type: typeId,
          list: newList
        }
      };
    });
  };

  getOrder = (list, where) => {
    this.setState(
      prevState => ({
        contentList: {
          type: prevState.content[0]?.id,
          list
        }
      }),
      () => {
        this.finalize();
      }
    );
  };

  checked = item => {
    this.setState(prevState => {
      let selectedLessons = prevState.selectedLessons
        ? [...prevState.selectedLessons]
        : [];
      let foundIndex = selectedLessons.findIndex(
        selected => selected.id === item.id
      );

      if (foundIndex !== -1) {
        selectedLessons.splice(foundIndex, 1);
      } else {
        selectedLessons.push(item);
      }

      return { selectedLessons };
    });
  };

  finalize = () => {};

  send = () => {
    this.props.getContent(this.state.contentList);
  };

  clearFilter = () => {
    this.setState(
      {
        disciplineId: undefined,
        filter: {
          word: "",
          segment: { value: null, label: "Todos" },
          discipline: { value: null, label: "Todos" },
          serie: { value: null, label: "Todas" },
          module: { value: null, label: "Todos" },
          ability: { value: null, label: "Todos" }
        }
      },
      () => {
        this.getLos();
      }
    );
  };

  render() {
    const content = this.state.content.reduce(
      (acc, val) => [
        ...acc,
        ...val.content.map(item => ({ ...item, type_id: val.id }))
      ],
      []
    );

    let segments = this.state.segments.map(segment => ({
      value: segment.id,
      label: segment.name,
      series: segment.series
    }));
    let series = [];
    let disciplines = [];

    if (this.state.filter.segment?.value) {
      series = segments
        .filter(segment => segment.value === this.state.filter.segment.value)
        .reduce((acc, val) => [...acc, ...val.series], [])
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    } else {
      series = segments
        .reduce((acc, val) => [...acc, ...val.series], [])
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    }

    if (this.state.filter.serie?.value) {
      disciplines = series
        .filter(serie => serie.value === this.state.filter.serie.value)
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.modules
        }));
    } else {
      disciplines = series
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.modules
        }));
    }

    segments = [
      { value: null, label: "Todos" },
      ...segments.filter(
        (s, i) => segments.findIndex(item => item.value === s.value) === i
      )
    ];
    series = [
      { value: null, label: "Todas" },
      ...series.filter(
        (s, i) => series.findIndex(item => item.value === s.value) === i
      )
    ];
    disciplines = [
      { value: null, label: "Todos" },
      ...disciplines.filter(
        (d, i) => disciplines.findIndex(item => item.value === d.value) === i
      )
    ];

    if (this.props.disciplinesSelected) {
      disciplines = this.props.disciplinesSelected;
    }

    return (
      <div className="animated">
        <NewContentModal
          id={this.state.type}
          show={this.state.newContentModal}
          onClose={() => this.setState({ newContentModal: false })}
          onImport={e =>
            this.props.getContent({ type: this.state.type, list: [e] })
          }
        />
        <Card className="mb-0 border-0">
          <CardHeader>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex flex-column flex-1">
                <h4 className="card-title mb-1">{this.props.typeName}</h4>
                <div className="small text-muted">
                  Veja os conteúdos desse tipo
                </div>
              </div>
              <div>
                <button
                  className="btn btn-secondary"
                  onClick={() => this.setState({ newContentModal: true })}
                >
                  <i className="fa fa-plus mr-2"></i>
                  <span>Importar</span>
                </button>
              </div>
            </div>

            <div className="row align-items-center mb-2">
              <InputGroup className="col-12 mb-3">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText className="bg-white pr-1">
                    <i className="fa fa-search text-muted"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Pesquisar por nome"
                  onChange={this.changeInputName}
                  value={this.state.filter.word || ""}
                  type="search"
                  autoComplete="off"
                />
              </InputGroup>
            </div>

            <div className="row">
              <div className="col-12 col-md-4 mb-2">
                <Label className="d-block w-100 text-ellipsis small text-muted">
                  Segmento
                </Label>
                <InputGroup>
                  <Select
                    className="react-select-container"
                    classNamePrefix="select"
                    placeholder="Segmento"
                    onChange={e => this.changeFilter("segment", e)}
                    value={this.state.filter.segment}
                    options={segments}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-4 mb-2">
                <Label className="d-block w-100 text-ellipsis small text-muted">
                  Série
                </Label>
                <InputGroup>
                  <Select
                    className="react-select-container"
                    classNamePrefix="select"
                    placeholder="Série"
                    onChange={e => this.changeFilter("serie", e)}
                    value={this.state.filter.serie}
                    options={series}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-4 mb-2">
                <Label className="d-block w-100 text-ellipsis small text-muted">
                  Componente Curricular
                </Label>
                <InputGroup>
                  <Select
                    className="react-select-container"
                    classNamePrefix="select"
                    placeholder="Disciplina"
                    onChange={e => this.changeFilter("discipline", e)}
                    value={this.state.filter.discipline}
                    options={disciplines}
                  />
                </InputGroup>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <div className="cardContent">
              {this.state.loading ? (
                <Loading top="16" left="34" />
              ) : (
                <Fragment>
                  {this.state.contentLength === 0 ? (
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center py-5">
                      <p className="m-0 text-muted">
                        Sem conteúdos disponíveis com os filtros selecionados.
                      </p>
                    </div>
                  ) : (
                    <Row
                      className="contentArea w-100"
                      style={{ marginTop: "-1rem" }}
                    >
                      {content.map((content, idc) => (
                        <Col sm="6" md="4" xl="3" key={idc}>
                          <ContentItemActivity
                            type={this.props.type}
                            activity
                            key={`content-${content.type_id}-${content.id}`}
                            content={content}
                            icon={this.props.typeIcon}
                            color={this.props.typeColor}
                            getSelected={this.getSelected}
                            send={() =>
                              this.props.getContent(this.state.contentList)
                            }
                            currentRoute={this.props.currentRoute}
                          />
                        </Col>
                      ))}
                    </Row>
                  )}
                </Fragment>
              )}
            </div>
          </CardBody>
          <CardFooter className="d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div className="mb-2 mb-md-0">
              <span>Total de Conteúdos: {this.state.contentLength}</span>
            </div>
            <CPagination
              className="mb-2 mb-md-0"
              addListClass="m-0"
              activePage={this.state.currentPage}
              pages={this.state.lastPage}
              onActivePageChange={page =>
                this.setState({ currentPage: page }, () => this.getLos())
              }
            />
            {this.props.activity && (
              <div>
                <Button onClick={this.clearFilter}>Limpar Filtros</Button>
                <Button color="primary" onClick={this.send} className="ml-2">
                  Enviar
                </Button>
              </div>
            )}
          </CardFooter>
        </Card>

        {this.state.contentList.list.length > 0 && this.state.modalOrder ? (
          <ModalActivity
            toggleModal={this.toggleModalOrder}
            modalState={this.state.modalOrder}
            title="Selecione os slides"
            className=" educandus modalActivity"
            backdrop="static"
            size="lg"
          >
            <Dnd
              list={this.state.contentList.list}
              getOrder={this.getOrder}
              direction="vertical"
              orderOnly
              checkbox
              getChecked={this.checked}
            />
          </ModalActivity>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentComponentActivity);
